<template>
  <div class="container-page">
    <p class="title-inner">ТЭС</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Год</th>
              <th>Страна</th>
              <th>Код ТН ВЭД</th>
              <th>Наименование товара</th>
              <th>Стоимость, тыс.$ США</th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.year }}</td>
              <td>{{ item.country?.nameFull || item.country?.name }}</td>
              <td>{{ item.nsiTnved?.code }}</td>
              <td>{{ item.nsiTnved?.name }}</td>
              <td>{{ item.value?.toFixed(5) }}</td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="5">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="5">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <ImportModal @doimport="doImport" @close="closeModal" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import ImportModal from '@/components/modals/ImportModal.vue';

  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.FtsView,
    import: Constants.Permissions.FtsImport,
  };

  export default {
    name: 'FtsCustoms',
    components: { ImportModal, ModalComponent, ButtonComponent },
    mixins: [security],
    data() {
      return {
        route: 'fts',
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        this.loadPage();
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        Api.search(this.route, this.request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
            this.importInProgress = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      closeModal() {
        this.importModal = false;
      },
    },
  };
</script>
